import { useQuery, useMutation } from "@apollo/client";
import {
  GET_PROJECT_OUTCOME,
  INSERT_PROJECT_OUTCOME,
  DELETE_PROJECT_OUTCOME,
} from "../../graphql/homepage/outcome";

export const useDisplayProjectOutcome = () => {
  return useQuery(GET_PROJECT_OUTCOME);
};

export const useInsertProjectOutcome = () => {
  return useMutation(INSERT_PROJECT_OUTCOME, {
    update(
      cache,
      { data: { insert_home_page_project_outcome_one: newOutcome } }
    ) {
      const existingOutcomes = cache.readQuery({ query: GET_PROJECT_OUTCOME });
      if (existingOutcomes && newOutcome) {
        cache.writeQuery({
          query: GET_PROJECT_OUTCOME,
          data: {
            home_page_project_outcome: [
              ...existingOutcomes.home_page_project_outcome,
              newOutcome,
            ],
          },
        });
      }
    },
  });
};

export const useDeleteProjectOutcome = () => {
  return useMutation(DELETE_PROJECT_OUTCOME, {
    update(cache, { data }, { variables }) {
      console.log("Mutation data:", data);
      console.log("Variables:", variables);

      const existingOutcomes = cache.readQuery({ query: GET_PROJECT_OUTCOME });

      if (existingOutcomes && variables?.id) {
        cache.writeQuery({
          query: GET_PROJECT_OUTCOME,
          data: {
            home_page_project_outcome:
              existingOutcomes.home_page_project_outcome.filter(
                (outcome) => outcome.id !== variables.id
              ),
          },
        });
      }
    },
  });
};
